import React, { useState, useEffect } from "react";
import api from "../../Axios/api";
import Pal from "../../themes/palette";
import MaterialTable from "material-table";
import { Grid, Paper, Typography } from "@material-ui/core";

// icons
import FeaturedVideoIcon from "@material-ui/icons/FeaturedVideo";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import WhatshotIcon from "@material-ui/icons/Whatshot";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import ImgNotAvailable from "../../assets/images/imgNotAvailable.jpg";
import Chart from "react-apexcharts";
import { useUserContext } from "../../context/UserContext";
import useStyles from "./styles";
import WeeklySales from "./WeeklySales";

// widget
import CountCard from "../CountCard/CountCard";
import DoughnutChart from "./DataBase-usage-chart";
import TopSellingProducts from "./TopSellingProducts";

const AdminAnalytics = () => {
  const [blueStyle, setBlueStyle] = useState({
    backgroundColor: "rgb(34,173,201)",
    gradientColor:
      "linear-gradient(90deg, rgba(34,173,201,1) 0%, rgba(57,89,178,1) 100%)",
  });
  const [orangeStyle, setOrangeStyle] = useState({
    backgroundColor: "rgb(255,181,53)",
    gradientColor:
      "linear-gradient(90deg, rgba(255,181,53,1) 0%, rgba(255,99,41,1) 100%)",
  });
  const [purpleStyle, setPurpleStyle] = useState({
    backgroundColor: "rgb(237,59,71)",
    gradientColor:
      "linear-gradient(90deg, rgba(237,59,71,1) 0%, rgba(174,39,166,1) 100%)",
  });
  const [greenStyle, setGreenStyle] = useState({
    backgroundColor: "rgb(58,181,75)",
    gradientColor:
      "linear-gradient(90deg, rgba(58,181,75,1) 0%, rgba(203,216,97,1) 100%)",
  });
  const { store } = useUserContext();
  const token = store.data.token;
  const { isDarkModeEnabled } = store.data.data;

  const [StatsCount, setStatsCount] = useState({
    stock: "0",
    investment: "0",
    revenue: "0",
    profit: "0",
  });
  const [dataCount, setDataCount] = useState({
    totalNumberOfBuyers: "0",
    totalActiveNumberOfStores: "0",
    totalNumberOfSellers: "0",
    totalNumberOfVendors: "0",
    totalNumberOfPendingStoreApprovals: "0",
    totalNumberOfActiveStoreProducts: "0",
    totalNumberOfStoreProducts: "0",
    totalNumberOfActiveVendorProducts: "0",
    totalNumberOfVendorProducts: "0",
    todayDeliveredOrdersCount: "0",
    totalDeliveredOrdersCount: "0",
    totalCancelledOrdersCount: "0",
    totalReturnedOrdersCount: "0",
    totalActiveOrdersCount: "0",
    totalPendingOrdersCount: "0",
  });
  const [salesData, setSalesData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [details, setDetails] = useState([]);
  const [buyerCount, setBuyerCount] = useState("");
  const [sellerCount, setSellerCount] = useState("");
  const [storeCount, setStoreCount] = useState("");

  const getTotalBuyers = () => {
    api
      .get("/superAdmin/buyers/totalNumber", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setBuyerCount(res.data.data.totalNumber);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };
  const getTotalSellers = () => {
    api
      .get("/superAdmin/sellers/totalNumber", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setSellerCount(res.data.data.totalNumber);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };
  const getTotalStores = () => {
    api
      .get("/superAdmin/stores/approved/number", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setStoreCount(res.data.data.totalNumber);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  var SalesStats = {
    series: [
      {
        name: "Sales / Day",
        data: salesData,
        fillColor: "#FF0000",
      },
    ],
    options: {
      xaxis: {
        type: "datetime",
      },
      theme: {
        mode: isDarkModeEnabled === true ? "dark" : "light",
      },
      colors: ["#DC143C"],
      fill: {
        colors: ["#DC143C"],
      },
      chart: {
        type: "line",
        zoom: {
          type: "x",
        },
        foreColor: isDarkModeEnabled === true ? "#f6f7f8" : "#373d3f",
      },
      stroke: {
        curve: "smooth",
        style: {
          colors: ["#F44336", "#E91E63"],
        },
      },
      title: {
        text: "Sales Reports",
        align: "center",
        style: {
          fontSize: "20px",
          fontFamily: "poppins",
        },
      },
      tooltip: {
        x: {
          format: "dd/MM/yy HH:mm",
        },
        theme: isDarkModeEnabled === true,
      },
    },
  };

  var CategoryWiseStats = {
    series: Object.values(categoryData),
    options: {
      theme: {
        mode: isDarkModeEnabled === true ? "dark" : "light",
      },
      title: {
        text: "Category-Wise Sales",
        align: "center",
        style: {
          fontSize: "20px",
          fontFamily: "poppins",
        },
      },
      chart: {
        type: "polarArea",
        foreColor: isDarkModeEnabled === true ? "#f6f7f8" : "#373d3f",
      },
      labels: ["Delivered", "Cancelled", "Returned", "Active", "Pending"],
      colors: ["#04e762", "#ff0a0a", "#ff4c00", "#1786dd", "#775DD0"],
      fill: {
        opacity: 1,
        colors: ["#04e762", "#ff0a0a", "#ff4c00", "#1786dd", "#775DD0"],
      },
      yaxis: {
        show: false,
      },
      legend: {
        position: "bottom",
      },
      plotOptions: {
        polarArea: {
          rings: {
            strokeWidth: 0,
          },
          spokes: {
            strokeWidth: 0,
          },
        },
      },
    },
  };

  var barChart = {
    series: [
      {
        name: "Sales / Day",
        data: salesData,
      },
    ],
    options: {
      theme: {
        mode: isDarkModeEnabled === true ? "dark" : "light",
      },
      colors: [Pal.palette.primary.main],
      title: {
        text: "Orders",
        align: "center",
        style: {
          fontSize: "20px",
          fontFamily: "poppins",
        },
      },
      chart: {
        type: "bar",
        height: 350,
        foreColor: isDarkModeEnabled === true ? "#f6f7f8" : "#373d3f",
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        type: "datetime",
      },
    },
  };

  // const retrivingTop5Products = async () => {
  //   await api
  //     .get("/seller/store/products", {
  //       headers: { Authorization: `Bearer ${token}` },
  //     })
  //     .then((res) => {
  //       setDetails(res.data.data.products);
  //     })
  //     .catch((error) =>
  //       console.log("ERROR: " + JSON.stringify(error.response.data.error))
  //     );
  // };

  const getStats = async () => {
    await api
      .get("/superAdmin/system/analytics", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        let result = res.data.data;

        let stock = result.vendorsProductsAnalytics[0].totalStock;
        let investment = result.vendorsProductsAnalytics[0].totalPurchasePrice;
        let revenue = result.vendorsProductsAnalytics[0].totalSalePrice;
        let profit = result.vendorsProductsAnalytics[0].totalProfit;
        console.log("analytics are ", res.data.data.vendorsProductsAnalytics);

        setStatsCount({
          ...StatsCount,
          stock,
          investment,
          revenue,
          profit,
        });

        // PieChart
        var AllCounts = res.data.data.allCounts;
        delete AllCounts.todayDeliveredOrdersCount;
        setCategoryData(AllCounts);

        let salesDatabyDates = res.data.data.salesListByDate.map((el) => {
          let x, y;
          x = new Date(el.date).toLocaleDateString();
          y = el.orders;
          return {
            x,
            y,
          };
        });

        // Sorting Sales Data w.r.t. Date
        salesDatabyDates.sort((a, b) => {
          let da = new Date(a.x),
            db = new Date(b.x);
          return da - db;
        });
        setSalesData(salesDatabyDates);
        // console.log("sales list data is ", salesData);
      })
      .catch((error) => console.log(error));
  };

  // useEffect(() => {
  //   // Retriving List of Products from API
  //   retrivingTop5Products();
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    getStats();
    // eslint-disable-next-line
    getTotalBuyers();
    // eslint-disable-next-line
    getTotalSellers();
    // eslint-disable-next-line
    getTotalStores();
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      title: "#",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
    },
    {
      title: "Image",
      field: "images",
      render: ({ images }) => (
        <img
          src={images.length > 0 ? images[0] : ImgNotAvailable}
          alt="ProductImage"
          style={{ width: 40, height: 40, borderRadius: "50%" }}
        />
      ),
      hidden: false,
      export: false,
    },
    { title: "Name", field: "name", hidden: false, export: true },
    {
      title: "description",
      field: "description",
      hidden: true,
      export: true,
    },
    { title: "Brand", field: "brand", hidden: false, export: true },
    { title: "Category", field: "category", hidden: true, export: true },
    {
      title: "purchasePrice",
      field: "purchasePrice",
      hidden: true,
      export: true,
    },
    {
      title: "Price",
      field: "salePrice",
      render: ({ salePrice }) => <div>{"$" + salePrice}</div>,
      hidden: false,
      export: true,
    },
    {
      title: "Stock",
      field: "stockAvailable",
      hidden: false,
      export: true,
    },
  ];
  return (
    <div>
      <Grid
        container
        spacing={4}
        // justify="space-between"
        style={{ marginBottom: 16 }}
      >
        <Grid item xs={12} md={6} lg={3}>
          <CountCard
            title="Total Admins"
            count="8"
            icon={<FeaturedVideoIcon style={{ fontSize: 50 }} />}
            backgroundColor={blueStyle.backgroundColor}
            gradientColor={blueStyle.gradientColor}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <CountCard
            title="Total Vendors"
            count={buyerCount}
            icon={<LocalAtmIcon style={{ fontSize: 50 }} />}
            backgroundColor={greenStyle.backgroundColor}
            gradientColor={greenStyle.gradientColor}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <CountCard
            title="Total Stores"
            count={storeCount}
            icon={<WhatshotIcon style={{ fontSize: 50 }} />}
            backgroundColor={orangeStyle.backgroundColor}
            gradientColor={orangeStyle.gradientColor}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <CountCard
            title="Total Buyers"
            count={buyerCount}
            icon={<AccountBalanceWalletIcon style={{ fontSize: 50 }} />}
            backgroundColor={purpleStyle.backgroundColor}
            gradientColor={purpleStyle.gradientColor}
          />
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6} lg={6}>
          <Paper
            style={{ padding: 16, marginTop: 5, width: 420, marginLeft: 20 }}
          >
            <Typography
              variant="h4"
              style={{
                fontWeight: "bold",
                textAlign: "center",
                marginRight: 5,
              }}
            >
              Database Usage
            </Typography>
            <DoughnutChart />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Paper style={{ padding: 16, height: 600 }}>
            <WeeklySales />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Paper style={{ padding: 16 }}>
            <TopSellingProducts />
            {/* <MaterialTable
              style={{ marginTop: 30 }}
              title={
                <Typography variant="h5" style={{ fontWeight: "bold" }}>
                  Top 5 Sellers
                </Typography>
              }
              data={details}
              columns={columns}
              options={{
                actionsColumnIndex: -1,
                headerStyle: {
                  backgroundColor: Pal.palette.primary.main,
                  color: "#fff",
                  fontWeight: "bold",
                },
                exportButton: false,
                search: false,
                paging: false,
              }}
            /> */}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default AdminAnalytics;
